import { FC } from 'react';

import Button from '@components/buttons/Button';
import IconButton from '@components/buttons/IconButton';
import { FormLabel } from '@components/form/FormLabel';
import { Input } from '@components/form/Input';
import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';

interface Link {
  type: string;
  text: string;
  url: string;
}

interface LinksListFieldProps {
  links: Link[];
  onChange: (links: Link[]) => void;
}

export const LinksListField: FC<LinksListFieldProps> = ({ links, onChange }) => {
  return (
    <>
      {links.map((link, index) => (
        <div key={index} className="d-flex gap-2 w-100">
          <div>
            <FormLabel text="Link Text" />
            <Input
              type="text"
              placeholder="eg. Website, YouTube, etc."
              defaultValue={link.text}
              onChange={(e) => {
                onChange(
                  links.map((prevLink, prevIndex) =>
                    prevIndex === index ? { ...prevLink, text: e.target.value } : prevLink,
                  ),
                );
              }}
            />
          </div>
          <div className="w-100">
            <FormLabel text="Link URL" />
            <div className="d-flex gap-2 align-items-center">
              <div className="w-100">
                <Input
                  type="text"
                  placeholder="eg. https://www.example.com"
                  defaultValue={link.url}
                  onChange={(e) => {
                    onChange(
                      links.map((prevLink, prevIndex) =>
                        prevIndex === index ? { ...prevLink, url: e.target.value } : prevLink,
                      ),
                    );
                  }}
                />
              </div>
              <IconButton
                variant="smooth"
                color="danger"
                onClick={() => {
                  onChange(links.filter((prevLink, prevIndex) => prevIndex !== index));
                }}
              >
                <FontAwesomeIcon name="times" />
              </IconButton>
            </div>
          </div>
        </div>
      ))}

      <Button
        variant="outlined"
        color="neutral"
        roundness="rounded"
        onClick={() => {
          onChange([...links, { type: 'custom', text: '', url: '' }]);
        }}
      >
        {links.length ? 'Add another link' : 'Add link'}
      </Button>
    </>
  );
};
